import { AppShell } from '@mantine/core';
import { FC, useContext, useEffect, useState } from 'react';
import { IconListCheck } from '@tabler/icons';
import { TaskListContextProvider } from '../../Service/Context/TaskListContext';
import TasksNavFilter from '../../Templates/Tasks/TasksNavFilter';
import { WindowContext } from '../../Service/Context/WindowContext';
import PageHeader from '../../Templates/Navigation/PageHeader';
import DoubleNavbar from '../../Molecules/DoubleNavbar';
import { RoutingS } from '../../Service/RoutingS';
import NavDrawer from '../../Atoms/NavDrawer';
import BookitupFooter from '../../Templates/Navigation/phone/BookitupFooter';
import TasksPageFooter from '../../Templates/Navigation/phone/TasksPageFooter';
import AllTasksList from './AllTasksList';

const Tasks: FC = () => {
  const { sm } = useContext(WindowContext);
  const [drawerOpened, setDrawerOpened] = useState(false);

  useEffect(() => {
    RoutingS.changeTitle('Aufgaben');
  }, []);

  return (
    <TaskListContextProvider>
      <AppShell
        navbar={
          sm ? undefined : (
            <DoubleNavbar>
              <TasksNavFilter />
            </DoubleNavbar>
          )
        }
        header={<PageHeader />}
        styles={(theme) => ({
          main: {
            minWidth: 0,
            backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[8] : '#fbfbfb',
          },
        })}
        footer={
          sm ? (
            <BookitupFooter>
              <TasksPageFooter filter={() => setDrawerOpened(true)} />
            </BookitupFooter>
          ) : undefined
        }
      >
        {sm && (
          <NavDrawer
            label="Aufgaben"
            icon={<IconListCheck size={32} />}
            opened={drawerOpened}
            onClose={() => setDrawerOpened(false)}
          >
            <TasksNavFilter closeDrawer={() => setDrawerOpened(false)} />
          </NavDrawer>
        )}
        <AllTasksList />
      </AppShell>
    </TaskListContextProvider>
  );
};

export default Tasks;
